<template>
  <div class="pca-plot-region">
    <div class="dropdown-container">
      <label for="custom-dropdown" class="dropdown-label">{{$tI_G('Narrow down by region dropdown')}}</label>
      <div class="select-custom-dropdown">
        <div class="dropdown-select" @click="toggleDropdown">{{ $t(selectedRegionName) || $t('Global') }}</div>
        <div class="custom-dropdown-menu cs-scroll-style" v-if="isDropdownOpen">
          <div 
            v-for="(item, index) in regionDatas" 
            :key="index" 
            class="custom-dropdown-item" 
            @click="toggleSubItems(index)"
          >
            {{ $t(item.groupName) }}
            <div v-if="item.regionList && item.isOpen" class="subitem-container">
              <div 
                v-for="(subItem, subIndex) in item.regionList" 
                :key="subIndex" 
                class="subitem"
                @click.stop="selectRegion(subItem)"
                v-click-track="'Iframe.ancientDnaGeneticDistanceMapsRegionChanged'"
              >
                {{ $t(subItem.regionName) }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {
  },
  props: {
    modalObject: {
      type: Object,
    },
    callback: {
      type: Function,
      default() {
        return {}
      },
    },
  },
  data() {
    return {
      isDropdownOpen: false,
      selectedRegion: null,

      regionDatas: [],
    }
  },
  methods: {
    applySelectedRegion() {
      this.$store.commit('pcaRegion/setSelectRegion', this.selectedRegion);
    },

    toggleDropdown() {
      this.isDropdownOpen = !this.isDropdownOpen;
    },
    toggleSubItems(index) {
      if (this.regionDatas[index].regionList) {
        this.$set(this.regionDatas[index], 'isOpen', !this.regionDatas[index].isOpen);
      } else {
        this.selectRegion(this.regionDatas[index].groupName);
        this.isDropdownOpen = false;
      }
    },
    selectRegion(region) {
      this.selectedRegion = region;
      this.isDropdownOpen = false;
      this.applySelectedRegion();
    }
  },
  computed: {
    selectedRegionName() {
      return this.selectedRegion ? this.selectedRegion.regionName : '';
    },
  },
  mounted() {
    this.$store.dispatch('pcaRegion/fetchRegionDatas', this.$store.state.kit.default_ethnicity).then(() => {
      this.regionDatas = this.$store.getters['pcaRegion/getRegionDatas'];
      this.selectedRegion = this.$store.getters['pcaRegion/getSelectedRegion'];
    });
  },
};
</script>

<style lang="scss" scoped>
.pca-plot-region {
  .dropdown-container {
    padding: 0;
    width: 100%;

    .select-custom-dropdown {
      width: 100%;
    }
  }
}

</style>
